// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-search-videos[data-v-432ec5dc] {
  height: 100%;
  overflow-y: auto;
  padding-left: 2px;
}
.media-search-videos .months-name[data-v-432ec5dc] {
  display: flex;
  justify-content: center;
  font-weight: 500;
  margin: 8px auto;
}
.media-search-videos .videos-wrapper[data-v-432ec5dc] {
  display: flex;
  position: relative;
  flex-direction: row;
  flex-wrap: wrap;
  flex-basis: content;
}
.media-search-videos .videos-wrapper .media-video-search[data-v-432ec5dc] {
  width: 110px;
  height: 110px;
  margin-top: 0px;
  margin-left: 1px;
}
.media-search-videos .videos-wrapper .publications-video-wrapper[data-v-432ec5dc] {
  margin-top: 0px;
  margin-left: 1px;
  display: flex;
  flex-wrap: wrap;
}
.media-search-videos .videos-wrapper[data-v-432ec5dc] .chat-video-wrapper,
.media-search-videos .videos-wrapper[data-v-432ec5dc] .message-btn-wrapper {
  border-radius: 0px;
  margin-bottom: 2px;
}
.media-search-videos .videos-wrapper[data-v-432ec5dc] .img-wrapper {
  height: 110px;
  border-radius: 2px;
}
.media-search-videos .videos-wrapper[data-v-432ec5dc] .chat-video-message {
  height: 100%;
}
.media-search-videos .videos-wrapper[data-v-432ec5dc] .publication-video-message {
  margin-left: 2px;
  margin-bottom: 3px;
}
.media-search-videos .videos-wrapper[data-v-432ec5dc] .publication-video-message .preview-block {
  display: flex;
  width: var(--preview-block-max-width);
  height: var(--preview-block-max-height);
}
.media-search-videos .videos-wrapper[data-v-432ec5dc] .publication-video-message .preview-block .message-btn-wrapper {
  border-radius: 10px;
}
.media-search-videos .videos-wrapper[data-v-432ec5dc] .publication-video-message .img-wrapper img {
  width: var(--image-width);
  height: var(--image-height);
  max-width: var(--image-max-width);
  max-height: var(--image-max-height);
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/mediaViewer/MediaSearchVideos.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;EACjC,mCAAmC;EACnC,iBAAiB;AACnB","sourcesContent":[".media-search-videos[data-v-432ec5dc] {\n  height: 100%;\n  overflow-y: auto;\n  padding-left: 2px;\n}\n.media-search-videos .months-name[data-v-432ec5dc] {\n  display: flex;\n  justify-content: center;\n  font-weight: 500;\n  margin: 8px auto;\n}\n.media-search-videos .videos-wrapper[data-v-432ec5dc] {\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex-basis: content;\n}\n.media-search-videos .videos-wrapper .media-video-search[data-v-432ec5dc] {\n  width: 110px;\n  height: 110px;\n  margin-top: 0px;\n  margin-left: 1px;\n}\n.media-search-videos .videos-wrapper .publications-video-wrapper[data-v-432ec5dc] {\n  margin-top: 0px;\n  margin-left: 1px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.media-search-videos .videos-wrapper[data-v-432ec5dc] .chat-video-wrapper,\n.media-search-videos .videos-wrapper[data-v-432ec5dc] .message-btn-wrapper {\n  border-radius: 0px;\n  margin-bottom: 2px;\n}\n.media-search-videos .videos-wrapper[data-v-432ec5dc] .img-wrapper {\n  height: 110px;\n  border-radius: 2px;\n}\n.media-search-videos .videos-wrapper[data-v-432ec5dc] .chat-video-message {\n  height: 100%;\n}\n.media-search-videos .videos-wrapper[data-v-432ec5dc] .publication-video-message {\n  margin-left: 2px;\n  margin-bottom: 3px;\n}\n.media-search-videos .videos-wrapper[data-v-432ec5dc] .publication-video-message .preview-block {\n  display: flex;\n  width: var(--preview-block-max-width);\n  height: var(--preview-block-max-height);\n}\n.media-search-videos .videos-wrapper[data-v-432ec5dc] .publication-video-message .preview-block .message-btn-wrapper {\n  border-radius: 10px;\n}\n.media-search-videos .videos-wrapper[data-v-432ec5dc] .publication-video-message .img-wrapper img {\n  width: var(--image-width);\n  height: var(--image-height);\n  max-width: var(--image-max-width);\n  max-height: var(--image-max-height);\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
